/* nm-geo.js — switch the visitor to the market matching their location (FR/BE/LU → EUR, CH → CHF), once per session */
(async () => {
  try {
    if (sessionStorage.getItem('nm_geo_done')) return;
    sessionStorage.setItem('nm_geo_done', '1');
    const cur = (window.Shopify && Shopify.country) || '';
    const r = await fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', { headers: { Accept: 'application/json' } });
    if (!r.ok) return;
    const d = await r.json();
    let cc = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
    if (!cc && d && d.suggestions && d.suggestions[0] && d.suggestions[0].parts && d.suggestions[0].parts.country) cc = d.suggestions[0].parts.country.handle;
    if (!cc || cc === cur) return;
    const form = document.querySelector('form[action*="/localization"]');
    const opts = form ? [...form.querySelectorAll('[name="country_code"] option, [data-value]')].map(o => o.value || o.dataset.value) : [];
    if (opts.length && !opts.includes(cc)) return;
    const f = document.createElement('form'); f.method = 'post'; f.action = '/localization'; f.style.display = 'none';
    const add = (n, v) => { const i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; f.appendChild(i); };
    add('form_type', 'localization'); add('utf8', '✓'); add('_method', 'put'); add('return_to', location.pathname + location.search); add('country_code', cc);
    document.body.appendChild(f); f.submit();
  } catch (e) { /* silent */ }
})();
